export var getPropertyDescription = function getPropertyDescription(guestsNumber, bedroomsNumber) {
  return "Guests: ".concat(guestsNumber).concat(bedroomsNumber ? " | Bedrooms: ".concat(bedroomsNumber) : '');
};